export default function Footer() {
  return (
    <footer className="fixed bottom-0 bg-white max-w-2xl dark:bg-dark-400 w-full py-2 text-center">
      <p>Checkout my <a href="https://marioyonan.com" className="text-brand-purple tracking-wide font-semibold">portfolio</a>!</p>
    </footer>
  )
}